
export const getFilePath = (file: string) => `/assets/files/${file?.split('/').pop()}`
